import { all, call, put, select, takeEvery } from "redux-saga/effects";

import { ToastContent, getToastContent } from "constants/toasts";
import { trackGTMEvent } from "helpers/analytics";
import { pushWithUTM } from "helpers/sagas";
import { SubscriptionRoutes } from "routes/subscription";
import { ApiManager } from "services/api";
import { deserializeSubscription, deserializeSubscriptions } from "services/api/subscription";
import { IRecurlyCoupon, RecurlyActions, getRecurlyNewCoupon } from "store/entities/recurly";
import { ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";

import { CRUDAction, IEntityCreate, IEntityUpdate, RequestAction } from "../actions";

import { SUBSCRIPTION, SubscriptionActions } from "./actions";
import { ISubscription } from "./interfaces";
import { selectCurrentSubscription } from "./selectors";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchCollection() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.subscriptionApi.fetchAll);
  if (response.result) {
    const subscriptions = deserializeSubscriptions(response.result);
    yield put(SubscriptionActions.fetchCollectionSuccess({ values: subscriptions }));
  } else {
    yield put(SubscriptionActions.fetchCollectionFailure({ error: null }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* create(action: IActionWithPayload<string, IEntityCreate<ISubscription>>) {
  const subscription = { ...action.payload.value };
  const coupon: IRecurlyCoupon = yield select(getRecurlyNewCoupon);

  let couponRedeemed = false;
  if (coupon && !coupon.redeemed) {
    subscription.couponCode = coupon.code;
    couponRedeemed = true;
  }
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.subscriptionApi.create, subscription);
  if (response.result) {
    if (couponRedeemed) {
      yield put(RecurlyActions.couponRedeemed());
    }
    const parsedSubscription = deserializeSubscription(response.result);
    yield put(SubscriptionActions.createSuccess({ id: parsedSubscription.id, value: parsedSubscription }));
    trackGTMEvent("subscribeAccount");
  } else if (
    subscription.couponCode &&
    response.responseStatus === 403 &&
    response.error &&
    response.error.error &&
    response.error.error.details &&
    response.error.error.details.source === "accounts"
  ) {
    // make couponCode as redeemed and retry creating subscription
    yield put(RecurlyActions.couponRedeemed());
    yield put(SubscriptionActions.create({ value: { ...action.payload.value } }));
  } else {
    yield put(SubscriptionActions.createFailure({ error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* update(action: IActionWithPayload<string, IEntityUpdate<ISubscription>>) {
  const subscription = { ...action.payload.value };
  const coupon: IRecurlyCoupon = yield select(getRecurlyNewCoupon);
  yield put(RecurlyActions.couponRedeemed());

  let couponRedeemed = false;
  if (coupon && coupon.redeemed === false) {
    subscription.couponCode = coupon.code;
    couponRedeemed = true;
  }
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.subscriptionApi.update, subscription);
  if (response.result) {
    if (couponRedeemed) {
      yield put(RecurlyActions.couponRedeemed());
    }
    const parsedSubscription = deserializeSubscription(response.result);
    // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    yield put(SubscriptionActions.updateSuccess({ id: subscription.id, value: parsedSubscription }));
  } else {
    // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    yield put(SubscriptionActions.updateFailure({ id: subscription.id, error: response.error.error.message }));
    yield put(
      ToastsActions.createToast({
        content: getToastContent(ToastContent.SUBSCRIPTION_UPDATE_FAILURE, {
          type: response.error.error.type,
          error: response.error.error.message,
        }),
        variant: ToastVariant.Error,
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteSubscription() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const subscription = yield select(selectCurrentSubscription);
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.subscriptionApi.deleteSubscription, subscription.id);
  if (response.result) {
    yield put(SubscriptionActions.deleteSuccess({ id: subscription.id }));
  } else {
    yield put(SubscriptionActions.deleteFailure({ id: subscription.id }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteSubscriptionSuccess() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.SUBSCRIPTION_DELETED),
      variant: ToastVariant.Success,
    })
  );

  yield put(pushWithUTM(SubscriptionRoutes.Plans));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* subscriptionsSaga() {
  yield all([
    takeEvery(SUBSCRIPTION[CRUDAction.FETCH_COLLECTION][RequestAction.REQUEST], fetchCollection),
    takeEvery(SUBSCRIPTION[CRUDAction.CREATE][RequestAction.REQUEST], create),
    takeEvery(SUBSCRIPTION[CRUDAction.UPDATE][RequestAction.REQUEST], update),
    takeEvery(SUBSCRIPTION[CRUDAction.DELETE][RequestAction.REQUEST], deleteSubscription),
    takeEvery(SUBSCRIPTION[CRUDAction.DELETE][RequestAction.SUCCESS], deleteSubscriptionSuccess),
  ]);
}
